var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4AAB8A;}\r\n\t.st1{fill:#C49755;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,12.3c0.1-0.4,0.4-0.6,0.7-0.8c0.3-0.1,0.9-0.2,1.7-0.3v-0.7c-1.2,0.1-3,0.1-5.3,0.1h-2.4L15.5,27 L8.6,10.6c-1.5,0.1-3.3,0.1-5.3,0.1c-1.2,0-2.2,0-2.9-0.1v0.7c0.7,0,1.3,0.1,1.6,0.3c0.3,0.1,0.6,0.4,0.7,0.8 c0.1,0.4,0.2,1,0.2,1.9v15.2c0,1.1-0.1,2-0.2,2.6c-0.1,0.6-0.4,1-0.7,1.3c-0.3,0.3-0.9,0.5-1.6,0.6v0.7c0.7-0.1,1.7-0.1,2.9-0.1 c1.6,0,2.8,0,3.6,0.1v-0.7c-1-0.1-1.7-0.3-2.2-0.6c-0.4-0.3-0.7-0.7-0.9-1.3c-0.1-0.6-0.2-1.6-0.2-2.9V12.8l9.1,21.7h0.5l8.1-21.2 v17.6c0,0.9-0.1,1.5-0.2,1.9c-0.1,0.4-0.4,0.6-0.8,0.8c-0.4,0.1-1,0.2-1.8,0.3v0.7c1.1-0.1,2.9-0.1,5.3-0.1s4.1,0,5.3,0.1v-0.7 c-0.7,0-1.3-0.1-1.6-0.3c-0.3-0.1-0.6-0.4-0.7-0.8c-0.1-0.4-0.2-1-0.2-1.9V14.1C26.8,13.3,26.9,12.7,27,12.3L27,12.3z M25,22.8 v2.4c0,0.4-0.4,0.8-0.8,0.8c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.5-0.4-0.5-0.7v-2.4c-0.6-0.3-1.1-1-1.1-1.7c0-1,0.8-1.9,1.9-1.9 c1,0,1.9,0.8,1.9,1.9C26.1,21.8,25.6,22.5,25,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,33.8v0.7c-1.6-0.1-3.3-0.1-5.3-0.1c-1.5,0-2.9,0-4.3,0.1v-0.7c0.6,0,1.1-0.1,1.4-0.2 c0.3-0.1,0.4-0.2,0.4-0.5c0-0.2-0.1-0.5-0.4-0.8l-4.9-7.9c-0.5-0.7-0.8-1.2-1.1-1.4c-0.3-0.2-0.7-0.4-1.2-0.4v-0.7 c0.9-0.1,1.7-0.3,2.4-0.8c0.7-0.5,1.6-1.3,2.5-2.4l2-2.4c1-1.2,1.6-2.2,1.6-3.1c0-0.5-0.2-1-0.7-1.3c-0.4-0.3-1.1-0.5-1.8-0.5 v-0.6c1.6,0.1,3.3,0.1,5,0.1c1.3,0,2.4,0,3.2-0.1v0.6c-1.8,0.4-3.4,1.5-4.9,3.2l-4.2,5l7.9,12.2c0.3,0.5,0.7,0.9,1,1.2 C48.6,33.3,49.1,33.5,49.6,33.8L49.6,33.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.1,45.1c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S36.8,45.1,35.1,45.1z M35.1,39.8 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S36.3,39.8,35.1,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,45.1c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1S33.2,45.1,31.5,45.1z M31.5,39.8 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S32.8,39.8,31.5,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,47.5c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S34.2,47.5,33.3,47.5z M33.3,45 c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S33.8,45,33.3,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,39.8c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S34.2,39.8,33.3,39.8z M33.3,37.3 c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S33.8,37.3,33.3,37.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,33.5h1c0.6,0,1.1,0.5,1.1,1.1V36c0,0.6-0.5,1.1-1.1,1.1h-1c-0.6,0-1.1-0.5-1.1-1.1v-1.3 C31.6,34,32.1,33.5,32.7,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,10.4h1c0.6,0,1.1,0.5,1.1,1.1v1.3c0,0.6-0.5,1.1-1.1,1.1h-1c-0.6,0-1.1-0.5-1.1-1.1v-1.3 C31.7,10.8,32.2,10.4,32.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,2.5h1c0.3,0,0.5,0.2,0.5,0.5v33.5c0,0.3-0.2,0.5-0.5,0.5h-1c-0.3,0-0.5-0.2-0.5-0.5V3 C32.3,2.7,32.5,2.5,32.8,2.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 6.8,
    className: "st1",
    width: 4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 5.8,
    className: "st1",
    width: 2.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 4,
    className: "st1",
    width: 4,
    height: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.8f727d43e69854b72c63fbb0b12a6a84.svg";
export { ForwardRef as ReactComponent };